import { render, staticRenderFns } from "./chirp-profile.vue?vue&type=template&id=2eb581b8&scoped=true&"
import script from "./chirp-profile.vue?vue&type=script&lang=js&"
export * from "./chirp-profile.vue?vue&type=script&lang=js&"
import style0 from "./chirp-profile.vue?vue&type=style&index=0&id=2eb581b8&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2eb581b8",
  null
  
)

export default component.exports